import { Fn } from 'types/common';
import actionCreatorFactory from 'typescript-fsa';

const ac = actionCreatorFactory();

export default {
  uploadImage: ac<{ data: FormData }>('uploadImage'),
  clearState: ac('clearState'),
};
